import {PlayerBaseService} from "./PlayerService/player.base.service";
import {ILogInfo} from "../interfaces/ILogInfo";

export enum LogPriority {
  ERROR = 0,
  WARNING = 1,
  INFO = 2,
  DEBUG = 3
}

export enum LogTag {
  GLOBAL_ERROR      = "global_error",
  INIT              = "init",
  DISPOSE           = "dispose",
  SERVICE_WORKER    = "service_worker",
  WEBSOCKET         = "websocket",
  TRANSITION        = "transition",
  PLAYER_SERVICE    = "player_service",
  PLAYER            = "player",
  SIGNAGE_PLAYER    = "signage_player",
  REGISTRATION      = "registration",
  CACHE             = "cache",
  TASKBAR           = "taskbar",
  SCENE_UPDATE      = "scene_update",
  PIXI              = "pixi",
  PROGRESS          = "progress",
  MAIN              = "main",
  CHROME_EXTENSION  = "chrome_extension",
  SCHEDULE          = "schedule"
}


export class Log {
  private static playerService: PlayerBaseService;
  public static devMode: boolean = false;
  public static config;

  public static init(playerService: PlayerBaseService) {
    Log.playerService = playerService;
    if (localStorage["logConfig"]!=null) {
      Log.config = JSON.parse(localStorage["logConfig"]);
      if (Array.isArray(Log.config.tags) == false) {
        Log.updateConfig( false, 0, []);
      }
    } else {
      Log.updateConfig( false, 0, []);
    }
  }

  public static updateConfig(enabled, priority, tags) {
    Log.config = {
      enabled: enabled,
      priority: priority,
      tags: tags
    };
    if (Array.isArray(Log.config.tags) == false) {
      Log.config.tags = [];
    }
    localStorage["logConfig"] = JSON.stringify(Log.config);
  }


  private static getSceneId(sender: any) {
    if (sender?.parentPlayer?.playerObject?.$?.id) {
      return "sceneId=" + sender.parentPlayer.playerObject.$.id + " ";
    }
    return "";
  }

  public static getLogInfo(className, fncName, fncArgs): ILogInfo {
    let args = "";
    try {
      args = JSON.stringify(fncArgs);
    } catch (e) {
    }
    return {
      className: className,
      fncName: fncName,
      fncArgs: args
    }
  }

  static format(sender: ILogInfo, tag: string, msg: string): string {
    return tag + " " + sender?.className + "." + sender?.fncName + sender?.fncArgs +  " " + msg
  }

  public static e(sender: ILogInfo, tag: string, msg: string) {
    const message = this.getSceneId(sender) + ": " + msg;
    console.error(Log.format(sender, tag, msg));
    if (Log.playerService!=null && Log.config.enabled && Log.config.priority >= LogPriority.ERROR) {
      Log.playerService.log(LogPriority.ERROR, sender, tag, message);
    }
  }

  public static w(sender: ILogInfo, tag: string, msg: string) {
    const message = this.getSceneId(sender) + ": " + msg;
    console.warn(Log.format(sender, tag, msg));
    if (Log.playerService!=null && Log.config.enabled && Log.config.priority >= LogPriority.WARNING) {
      Log.playerService.log(LogPriority.WARNING, sender, tag, message);
    }
  }

  public static i(sender: ILogInfo, tag: string, msg: string) {
    const message = this.getSceneId(sender) + ": " + msg;
    console.log(Log.format(sender, tag, msg));
    if (Log.playerService!=null && Log.config.enabled && Log.config.priority >= LogPriority.INFO) {
      Log.playerService.log(LogPriority.INFO, sender, tag, message);
    }
  }

  public static d(sender: ILogInfo, tag: string, msg) {
    const message = this.getSceneId(sender) + " " + msg;
    let containTag = false;
    for(let i=0; i<Log.config.tags.length; i++) {
      if (Log.config.tags[i]==tag) {
        containTag = true;
        break;
      }
    }

    //if (tag==LogTag.PLAYER) {
      // console.log(Log.format(sender, tag, msg));
    //}

    if (containTag) {
      if (Log.playerService != null && Log.config.enabled && Log.config.priority >= LogPriority.DEBUG) {
        console.log(Log.format(sender, tag, msg));
        Log.playerService.log(LogPriority.DEBUG, sender, tag, message);
      }
    }
  }

  public static debug() {
      /*
    if (Log.playerService!=null && Log.playerService.runInStudio()==false) {
      debugger;
    }

       */
  }
}
